import moment from "moment-timezone";
import currency from "currency.js";

export const fmtDate = (val, none = "") => (val ? moment(val).format("MMM D, YYYY") : none);
export const fmtDate2 = (val) => (val ? moment(val).format("M/D/YYYY") : "");
export const fmtDateTime = (val) => (val ? moment(val).format("M/D/YY, h:mma") : "");
export const fmtDateTime1 = (val, tz) => (val ? moment.tz(val, tz).format("M/D/YY, h:mma") : "");
export const fmtDateTime2 = (val, none = "") => (val ? moment(val).format("MMM D, h:mma") : none);

export const timezones = [
  { key: "America/New_York", val: "Eastern Daylight Time" },
  { key: "America/Chicago", val: "Central Daylight Time" },
  { key: "America/Denver", val: "Mountain Daylight Time" },
  { key: "America/Phoenix", val: "Mountain Standard time" },
  { key: "America/Los_Angeles", val: "Pacific Daylight Time" },
  { key: "America/Anchorage", val: "Alaska Daylight Time" },
  { key: "Pacific/Honolulu", val: "Hawaii-Aleutian Standard Time" },
];

export const defaultFormLayout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const fmtMoney = (val) => currency(val, { precision: 0 }).format();
export const fmtMoney2 = (val, none = "-", unit = "") => (val ? currency(val, { precision: 2 }).format() + unit : none);

export const timeDuration = ({ start, end }) => {
  return `${moment(start).format("MMM D")} - ${moment(end).format("MMM D, YYYY")}`;
};

export const sortByObjName = (a, b) => {
  return a?.name?.toLowerCase()?.localeCompare(b?.name?.toLowerCase());
};

export const sleep = async (ms) => {
  return new Promise((r) =>
    setTimeout(async () => {
      r(null);
    }, ms)
  );
};

export const Utils = {
  defaultFormLayout,
  hasKey: (obj, key) => Object.keys(obj).includes(key),
  fmtDateTime,
  fmtDate,
  fmtMoney,
  timeDuration,
  sortByObjName,
};

export const list2tree = (list: any[], pid: string | null): any[] => {
  const nodes = list.filter((x) => x.pid === pid).map((x) => ({ ...x }));
  if (nodes.length > 0) {
    nodes.forEach((x) => {
      const children = list2tree(list, x.id);
      if (children.length > 0) {
        x.children = children;
      }
    });
  }
  return nodes;
};

export const tree2TreeData = (nodes: any[], curId: any): any[] => {
  return nodes
    .filter((x) => x.id !== curId)
    .map((x) => {
      return {
        title: x.name,
        key: x.id,
        value: x.id,
        children: tree2TreeData(x.children || [], curId),
      };
    });
};

export const formatBytes = (bytes, decimals = 1) => {
  if (bytes === 0) return "0B";
  var k = 1024,
    sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + "" + sizes[i];
};

export const formatHours = (hours: number) => {
  if (Number.isInteger(hours)) {
    return `${hours} ${hours === 1 ? "Hour" : "Hours"}`;
  } else {
    return `${hours.toFixed(1)} Hours`;
  }
};

export const dataURItoBlob = (b64Data, filename) => {
  var sliceSize = 512;
  var byteCharacters = atob(b64Data);
  var byteArrays: any[] = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var file = new File(byteArrays, filename, {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  return file;
};
